import Repository from "./Repository";

const ADD = "add";
const GETALL = "all";
const GETALBUM = "getById"
const GETGALLERIES = "allGalleries";
const GETGALLERY = "getGalleryById"
const EDITALBUM = "edit"
const DELETE = "delete"
const REMOVEIMAGE = "removeImage"


export default {
    add(payload) {
        return Repository.post(transformRoute(ADD), payload);
    },

    allGalleries(payload) {
        return Repository.get(transformRoute(GETGALLERIES), payload);
    },

    getGalleryById(payload) {
        return Repository.post(transformRoute(GETGALLERY), payload);
    },

    all(payload) {
        return Repository.get(transformRoute(GETALL), payload);
    },

    getAlbumById(payload) {
        return Repository.post(transformRoute(GETALBUM), payload);
    },

    edit(payload) {
        return Repository.put(transformRoute(EDITALBUM), payload);
    },

    delete(payload) {
        return Repository.post(transformRoute(DELETE), payload);
    },

    removeImage(payload) {
        return Repository.post(transformRoute(REMOVEIMAGE), payload);
    }

};

const transformRoute = (route) => {
    return `/gallery/${route}`;
};
